module.exports = __webpack_public_path__ + "static/media/portrait.da07c377.webp";